import classNames from 'classnames';
import { Button, ButtonProps } from 'antd';

import './styles.scss';

export interface AppButtonProps extends ButtonProps {
  appVariant?: ComponentVariant;
}

export function AppButton({
  appVariant: variant,
  className,
  children,
  ...rest
}: AppButtonProps) {
  return (
    <Button {...rest} className={classNames('app-button', `app-button-${variant}`, className)}>
      {children}
    </Button>
  );
};

export default AppButton;
